export const INVITE_TYPE = {
	REFERRER: "referrer",
	REFEREE: "referee",
};

export const HUBSPOT_CUSTOM_EVENT_API =
	"/lead-collection-integration/hub-event/";
export const ACTIVE_CAMPAIGN_URL =
	"https://us-central1-playground-206205.cloudfunctions.net/microsite-utils/active-campaign/sync";
